<router-outlet>
</router-outlet>

<!-- minimized email tab -->
<div class="minimized-email-tabs">
  <div class="minimized-email-tabs__container">
    @for (email of minimizedEmails; track email.id) {
      <div class="minimized-tab">
        <span class="minimized-tab__label">{{email.emailData.subject || '(draft)'}}</span>
        <atom-image (click)="maximizeMessage(email.id)"
          class="minimized-tab__icon" type="icon"
          [src]="icons.Maximize"
          [size]="size.md"
          [color]="colors.Blue">
        </atom-image>
      </div>
    }
  </div>
</div>
@for (alert of alertService.alertsTop; track alert.id; let index = $index) {
  <atom-snackbar
    [severity]="alert.severity"
    [anchor]="alert.anchor"
    [gap]="(index * 56) + 16 + 'px'"
    [full]="alert.full"
    [animation]="false"
    >
    <div text-top>{{alert.title}}</div>
    @if (alert?.actions?.length > 0) {
      <div post-top>
        @for (action of alert.actions; track action.alertId || action.title || action.type) {
          <div>
            @if (action.action && action.type !== 'icon') {
              <atom-button
                [width]="action.width ? action.width :'250px'" type="secondary"
                (click)="action.action('')">
                <div text>{{action.title}}</div>
              </atom-button>
            }
            @if (action.type === 'icon') {
              <atom-image class="close" [type]="'icon'"
                [src]="icons.Close"
                [color]="colors.White"
              (click)="remove(alert)"></atom-image>
            }
          </div>
        }
      </div>
    }
  </atom-snackbar>
}

@if (alertService && alertService.alertsVisible) {
  @for (alert of alertService.alertsBottom; track alert.id; let index = $index) {
    <atom-snackbar
      [severity]="alert.severity"
      [anchor]="alert.anchor"
      [gap]="(index * 56) + 'px'"
      [full]="alert.full"
      [animation]="false"
      >
      <div text-bottom>{{alert.title}}</div>
      @if (alert?.actions?.length > 0) {
        <div post-bottom>
          <div class="d-flex align-items-center gap-2">
            @for (action of alert.actions; track action.alertId || action.title || action.type) {
              <div>
                @if (action.action && action.type !== 'icon') {
                  <atom-button
                    [width]="action.width ? action.width :'250px'" type="secondary"
                    (click)="action.action('')">
                    <div text>{{action.title}}</div>
                  </atom-button>
                }
                @if (action.type === 'icon' && alert.showClose) {
                  <atom-image class="close" type="icon"
                    [src]="icons.Close"
                    [color]="colors.White"
                  (click)="remove(alert)"></atom-image>
                }
              </div>
            }
          </div>
        </div>
      }
    </atom-snackbar>
  }
}

